import { render, staticRenderFns } from "./contentFooter.vue?vue&type=template&id=4230e1b2&scoped=true"
import script from "./contentFooter.vue?vue&type=script&lang=js"
export * from "./contentFooter.vue?vue&type=script&lang=js"
import style0 from "./contentFooter.vue?vue&type=style&index=0&id=4230e1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4230e1b2",
  null
  
)

export default component.exports